module.exports = __webpack_public_path__ + "static/img/woman.e651ccdb.png";